import {PAYMENT_STATE} from "./paymentModule";

export const paymentMutations = {

    clearPaymentState(state) {
        console.log('initializing payment state');
        state.payment = PAYMENT_STATE;
    },

    showPayForm(state, isVisible) {
        state.payment.formVisible = isVisible;
    },

    incrementFailedPayments(state) {
        state.payment.failedCount++;
    },

    incrementPaymentAttempts(state) {
        state.payment.attemptCount++;
    },

    setCaptchaKey(state, key) {
        state.payment.captchaKey = key;
    },

    setCaptchaValue(state, value) {
        state.payment.captchaValue = value;
    },

    setTncAccepted(state, isAccepted) {
        state.payment.tncAccepted = isAccepted;
        if (isAccepted) {
            this.commit('clearPaymentError', 'tnc');
        }
    },

    setCCEntered(state) {
        state.payment.ccEntered = true;
    },

    setExpEntered(state) {
        state.payment.expEntered = true;
    },

    setCvvEntered(state) {
        state.payment.cvvEntered = true;
    },

    setPaymentError(state, error) {
        state.payment.errors = {...state.payment.errors, [error.field]: error}
        this.commit('setBusy', false);
    },

    setOfflineSignup(state, value) {
        state.payment.offlineSignup = value;
    },

    clearPaymentError(state, field) {
        delete state.payment.errors[field];
    },

    clearAllPaymentErrors(state) {
        state.payment.errors = [];
    },

    setPaymentFormInitialized(state) {
        state.paymentFormInitialized = true
    }
}
